import React, { useEffect, useState } from 'react';
import { Icon } from '@iq/react-components';
import './PermissionsSelectorField.scss';

const splitCamelCase = (string_) => string_.replaceAll(/([a-z](?=[A-Z]))/g, '$1 ');

const PermissionsSelectorField = (properties) => {
  const {
    onChange,
    name,
    formData,
    schema: { includeList },
  } = properties;

  const [data, setData] = useState(formData || [false, false, false, false]);

  useEffect(() => {
    onChange(data);
  }, [data, onChange]);

  return (
    <div className="permissions-wrapper">
      <div className="permission-checkbox-container">
        <div className="permission-label">{splitCamelCase(name)}</div>

        {Array.from({ length: 4 })
          .fill(null)
          .map((_, index) => {
            const key = `checkbox-${index}`;
            if (index === 0) {
              return includeList.includes(name) ? (
                <Icon
                  key={key}
                  icon={data[index] ? 'toggle-on' : 'toggle-off'}
                  size="m"
                  className={data[index] ? 'permission-checkbox-checked' : 'permission-checkbox'}
                  onClick={() => setData((p) => p.with(index, !p[index]))}
                />
              ) : (
                <div
                  key={key}
                  style={{ width: '32px', height: '32px' }}
                ></div>
              );
            }

            if (name.includes('Docs') && index >= 2) {
              return (
                <React.Fragment key={key}>
                  <Icon
                    icon={data[index] ? 'he-checkbox-selected' : 'he-checkbox'}
                    size="m"
                    disabled
                    className={'disabled-permission'}
                  />
                  <span className="dash-indicator">-</span>
                </React.Fragment>
              );
            }
            return (
              <Icon
                key={key}
                icon={data[index] ? 'he-checkbox-selected' : 'he-checkbox'}
                size="m"
                className={data[index] ? 'permission-checkbox-checked' : 'permission-checkbox'}
                onClick={() => setData((p) => p.with(index, !p[index]))}
              />
            );
          })}
      </div>
    </div>
  );
};

export default PermissionsSelectorField;
